import { BUSINESS_TX_TABLE_SORT_ENABLED, BUSINESS_TX_TABLE_SORT_DISABLED } from '../actions/business_tx_table_sort'

export function businessTransactionSort(state = { sortField: null, order: null }, action) {
  switch (action.type) {
    case BUSINESS_TX_TABLE_SORT_ENABLED:
      return { ...state, sortField: action.sortField, order: action.order }
    case BUSINESS_TX_TABLE_SORT_DISABLED:
      return { ...state, sortField: null, order: null }
    default:
      return state
  }
}
